import { useEffect, useRef, useState } from 'react';

import useGoogleGeolocationLibrary from 'hooks/geolocation/use-google-geolocation-library';

const LOCATION_LENGTH_THRESHOLD_FOR_PREDICTIONS = 3;

function useLocationPredictions(
  location,
  { includeExactMatch = false, matchTypes = [], skipPredictions = false } = {}
) {
  const { libraryLoaded } = useGoogleGeolocationLibrary();
  const [predictions, setPredictions] = useState([]);
  const autocompleteServiceRef = useRef();

  if (libraryLoaded && !autocompleteServiceRef.current) {
    autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();
  }

  useEffect(() => {
    if (!libraryLoaded || skipPredictions) {
      return;
    }

    if (!location || location.length < LOCATION_LENGTH_THRESHOLD_FOR_PREDICTIONS) {
      setPredictions([]);
      return;
    }

    const request = {
      input: location,
      types: matchTypes,
    };

    autocompleteServiceRef.current.getPlacePredictions(request, (results, status) => {
      const hasResults = status === 'OK' && results && results.length;
      setPredictions(hasResults ? results : []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryLoaded, location]);

  if (!includeExactMatch) {
    return predictions.filter(prediction => prediction.description !== location);
  }

  return predictions;
}

export default useLocationPredictions;
